import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { publicApi } from '../utils/api';
import './LandingPage.css';

const BENEFITS = [
  { icon: '💻', title: 'Custom Software', desc: 'Built for your unique business need' },
  { icon: '🚀', title: 'Free Delivery',   desc: 'No cost to selected businesses' },
  { icon: '📣', title: 'Brand Story',     desc: 'Featured as a success story' },
  { icon: '🤝', title: 'Ongoing Support', desc: 'Post-launch guidance included' },
];

const STEPS = [
  { n:1, title: 'Apply Online', desc: 'Fill in your company details and business challenge' },
  { n:2, title: 'We Review',    desc: 'Our team evaluates all applications after the deadline' },
  { n:3, title: 'Discovery Meeting', desc: 'Shortlisted businesses meet with our team' },
  { n:4, title: 'We Build & Deliver', desc: 'Your custom software solution is developed and deployed' },
];

export default function LandingPage() {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    publicApi.getCampaign().then(r => setCampaign(r.data)).catch(() => {});
  }, []);

  const deadline = campaign?.application_deadline
    ? new Date(campaign.application_deadline).toLocaleDateString('en-LK', { day:'numeric', month:'long', year:'numeric' })
    : '30 June 2026';

  return (
    <div className="landing">
      {/* Nav */}
      <nav className="landing-nav">
        <div className="landing-nav__logo">Adeona <span>Technologies</span></div>
        <Link to="/apply" className="btn btn--primary">Apply Now</Link>
      </nav>

      {/* Hero */}
      <section className="hero">
        <div className="hero__badge">🌱 2026 Initiative — Sri Lanka</div>
        <h1>We're Empowering<br/>10 SMEs with Free<br/>Software Solutions</h1>
        <p>Tell us your biggest business challenge. We'll build a custom digital solution — at no cost to you.</p>
        <Link to="/apply" className="btn btn--white">Apply Now — It's Free →</Link>
        <div className="hero__deadline">⏳ Applications close {deadline}</div>
      </section>

      {/* Benefits */}
      <section className="section">
        <h2 className="section__title">What you get</h2>
        <p className="section__sub">Selected businesses receive end-to-end digital transformation</p>
        <div className="benefits-grid">
          {BENEFITS.map(b => (
            <div key={b.title} className="benefit-card">
              <div className="benefit-card__icon">{b.icon}</div>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <hr className="divider" />

      {/* Eligibility */}
      <section className="section">
        <h2 className="section__title">Who can apply?</h2>
        <p className="section__sub">We welcome all Sri Lankan SMEs with a clear business challenge</p>
        <div className="card">
          {[
            ['✓', 'Small & Medium Businesses', 'Any industry, any district across Sri Lanka'],
            ['✓', 'Clear Problem Statement', 'You have a specific manual process to automate'],
            ['✓', 'Open to Collaboration', 'Willing to work with our team through the process'],
          ].map(([mark, title, desc]) => (
            <div key={title} className="elig-row">
              <div className="elig-row__mark">{mark}</div>
              <div><h4>{title}</h4><p>{desc}</p></div>
            </div>
          ))}
        </div>
      </section>

      <hr className="divider" />

      {/* Process */}
      <section className="section">
        <h2 className="section__title">How it works</h2>
        <p className="section__sub">Simple 4-step process from application to delivery</p>
        {STEPS.map(s => (
          <div key={s.n} className="process-step">
            <div className="process-step__num">{s.n}</div>
            <div><h4>{s.title}</h4><p>{s.desc}</p></div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="section section--cta">
        <Link to="/apply" className="btn btn--primary btn--full" style={{borderRadius: 'var(--r)', padding:'14px'}}>
          Start Your Application →
        </Link>
        <p style={{textAlign:'center', fontSize:'12px', color:'var(--text3)', marginTop:'10px'}}>
          Even if not selected, receive a free 30-minute consultation
        </p>
      </section>

      <footer className="landing-footer">
        <p>© 2026 Adeona Technologies · Sri Lanka</p>
        <p><a href="mailto:info@adeona.lk">info@adeona.lk</a></p>
      </footer>
    </div>
  );
}
